export default {
  title: 'Detalii comandă',
  order_again: 'Comandă din nou',
};
